import { Component } from '@angular/core';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-new-password-success',
  templateUrl: './new-password-success.component.html',
  styleUrls: ['./new-password-success.component.scss'],
  imports: [
    HeaderAppComponent,
    FormTemplateComponent,
    PayeeButtonComponent,
    RouterLink,
  ],
})
export class NewPasswordSuccessComponent {}
